import React from "react";
import FadeIn from "react-fade-in";
import Button from "../Button";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { Badge } from "./subcomponents/Badges";

export const TerminologyPage: React.FC<{
  onComplete: () => void;
  onBack: () => void;
}> = ({ onComplete, onBack }) => {
  return (
    <div className="mx-auto max-w-[800px]">
      <h2 className="text-2xl mb-5">
        Your First <span className="font-semibold">Policy</span>
      </h2>
      <p className="mb-3">
        It can be helpful to understand some basic terminology that Oso uses to
        make authorization decisions. Some of these will likely be familiar, but
        some are specific to how Oso works.
      </p>
      <div className="mt-3" />
      <FadeIn>
        <div className="space-y-4">
          <ul className="list-disc pl-6 space-y-2">
            <li>
              An <Badge>Actor</Badge> is an entity (often a User) that requests
              an action
            </li>
            <li>
              A <Badge>Resource</Badge> is an object you want to protect
            </li>
            <li>
              <Badge>Roles</Badge> are labels (e.g., &quot;viewer&quot;,
              &quot;owner&quot;) used inside facts to grant permissions.
            </li>
            <li>
              <Badge>Facts</Badge> are data records that model relationships
              among specific Actors, Resources, Roles, or other attributes.
            </li>
          </ul>

          <p>Now, we&apos;ll walk through setting up a simple policy.</p>

          <div className="mt-6 flex justify-between">
            <Button icon={<AiOutlineArrowLeft />} medium onClick={onBack}>
              Go Back
            </Button>
            <Button
              theme="primary"
              icon={<AiOutlineArrowRight />}
              medium
              onClick={onComplete}
            >
              Got it
            </Button>
          </div>
        </div>
      </FadeIn>
    </div>
  );
};
